import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./en.json";
import translationFA from "./fa.json";

const resources = {
  en: { translation: translationEN },
  fa: { translation: translationFA }
};

const savedLang = localStorage.getItem("lang") || "fa";

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLang,
    fallbackLng: "en",
    interpolation: { escapeValue: false }
  });

export default i18n;